<template>
  <div
    :class="{
      [$style['label-input']]: true,
      [$style['disabled']]: disabled,
      [$style['large-space']]: largeSpace,
      [$style['inline']]: inline,
      [$style['size-small']]: sizeSmall,
    }"
  >
    <form @submit.prevent="handleFormSubmit">
      <label
        v-if="label"
        :class="$style['label']"
        v-color="colorFont"
        v-font-style="fontDetail"
        >{{ label }}</label
      >
      <input
        v-border-color="colorFont"
        v-color="colorFont"
        v-font-style="fontDetail"
        v-model="input"
        :placeholder="placeholder"
        :inputmode="inputmode"
        :type="type"
        :class="{ [$style['input']]: true, [$style['bold']]: bold }"
      />
    </form>
    <arrow-right
      v-if="showArrow"
      :class="$style['proceed']"
      :color="colorPrimary"
      @iconClicked="handleFormSubmit"
    />
  </div>
</template>

<script>
import ArrowRight from '@components/arrow-right.vue'
export default {
  components: {
    ArrowRight,
  },
  props: {
    bold: {
      type: Boolean,
      default: false,
    },
    colorFont: {
      type: String,
      default: '',
    },
    colorPrimary: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fontDetail: {
      type: Object,
      default: () => {},
    },
    inline: {
      type: Boolean,
      default: false,
    },
    inputmode: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    largeSpace: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    sizeSmall: {
      type: Boolean,
      defaut: false,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    input: '',
  }),
  methods: {
    handleFormSubmit() {
      if (!this.input) {
        return
      }
      this.$emit('formSubmit')
    },
  },
  watch: {
    input() {
      this.$emit('input', this.input)
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.input {
  line-height: normal;
}

.label-input {
  position: relative;

  &.large-space {
    padding-top: 48px;
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &.inline {
    padding-top: 0;

    .input {
      margin-right: 8px;
      width: auto;

      &::placeholder {
        text-transform: none;
      }
    }
  }

  &.size-small {
    max-width: 160px;
  }

  form {
    display: flex;
    flex-direction: column;

    .label {
      padding-bottom: 18px;
    }

    .input {
      border-style: solid;
      border-width: 1px;
      border-radius: 0;
      box-sizing: border-box;
      height: 48px;
      font-size: 14px;
      line-height: normal;
      padding: 0 0 0;
      text-align: center;
      width: 100%;
      -webkit-appearance: none;

      &::placeholder {
        font-weight: normal;
      }

      &:focus {
        border-width: 2px;
        outline: 0;
      }

      &.--bold {
        font-weight: bold;
      }
    }
  }

  .proceed {
    position: absolute;
    right: 8px;
    bottom: 16px;
  }
}
</style>
